import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Snackbar,
  Typography,
  Divider,
  Icon,
  Card,
  Grid,
  Paper,
  IconButton,
  Menu,
  Toolbar,
  AppBar,
  MenuItem,
  Button,
  Link,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppHeader from "../../components/header";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import usePageTitle from "../../pageTitle";

function CampaignPage() {
  const [pageTitle, setPageTitle] = useState("WebStore");
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [campaignReference, setCampaignReference] = useState(null);
  const [webstore, setWebstore] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`webstore/campaign/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setWebstore(result.data.data.webstore);
            setCampaign(result.data.data.campaign);
            setPageTitle(
              `Laddar Africa | ${result.data.data.webstore.title} | ${result.data.data.campaign.title}`
            );
            setProducts(result.data.data.products);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);

            navigate("/error");
            return;
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();

    setCampaignReference(ref);
    console.log(campaignReference);
  }, []);
  return (
    <>
      <Box sx={{ flexGrow: 1 }} mb={10}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
        {webstore !== null ? (
          <>
            <Box mb={7}>
              <AppBar>
                <Toolbar>
                  <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                  >
                    <img
                      // src="https://placehold.co/600x400.png"
                      src={`${AppConfig.api_media_url}${webstore.logo}`}
                      alt="img"
                      width="24px"
                    />
                  </IconButton>
                  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {webstore.title}
                  </Typography>
                  {/* <div>
                <IconButton size="large" color="inherit">
                  <Icon>shopping_cart</Icon>
                </IconButton>
              </div> */}
                </Toolbar>
              </AppBar>
            </Box>
            <Box
              sx={{
                bgcolor: (theme) => "white.900",
                color: (theme) => "grey.700",
                // border: "1px solid",
                borderColor: (theme) =>
                  theme.palette.mode === "dark" ? "grey.800" : "grey.300",
                borderRadius: 2,
                p: 1,
                fontSize: "0.875rem",
                fontWeight: "700",
                position: "relative",
                margin: "0px auto",
                maxWidth: "800px",
              }}
            >
              <Box>
                <AppHeader webstore={webstore} />
                <Box mt={5}>
                  <ListItem
                    key={campaign.reference}
                    sx={{ py: 1, px: 0 }}
                    onClick={() =>
                      navigate(`/ws/categories/${campaign.reference}`)
                    }
                  >
                    <ListItemText
                      sx={{ mr: 2 }}
                      primary={
                        <Typography fontSize={18} fontWeight={700}>
                          {campaign.title}
                        </Typography>
                      }
                    />
                    <Box align="right">
                      <Icon color="">apps</Icon>
                    </Box>
                  </ListItem>
                  <Divider />
                </Box>
                <Box mt={5} align="center">
                  {products.length > 0 ? (
                    <Grid container spacing={3}>
                      {products.map((product, index) => (
                        <Grid item xs={12} md={4} lg={4} key={index}>
                          <Card elevation={3}>
                            <Box p={3} align="center">
                              <img
                                src={`${AppConfig.api_media_url}${
                                  product.images.length > 0
                                    ? product.images[0]
                                    : webstore.logo
                                }`}
                                alt="img"
                                style={{
                                  "max-height": "100px",
                                  "max-width": "80%",
                                }}
                              />
                              <Box mt={2}>
                                <Typography variant="h6">
                                  <small>{product.currency}</small>
                                  {(product.price / 100).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  fontWeight={100}
                                  mt={3}
                                >
                                  {product.title}
                                </Typography>
                              </Box>
                            </Box>
                            <Box mt={2}>
                              <Button
                                fullWidth
                                endIcon={<Icon>keyboard_arrow_right</Icon>}
                                variant="contained"
                                onClick={() => {
                                  navigate(`/ws/product/${product.reference}`);
                                }}
                              >
                                View
                              </Button>
                            </Box>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <>
                      <Typography variant="h6" fontWeight={400}>
                        No products found
                      </Typography>
                      <Box mt={1}>
                        <Button
                          startIcon={<Icon>arrow_back_rounded</Icon>}
                          onClick={() => {
                            window.history.back();
                          }}
                        >
                          Go Back
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
          </>
        ) : (
          <> </>
        )}
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default CampaignPage;
